module.exports = __webpack_public_path__ + "img/chapter__5_image_1.286a8481.jpg";